import { paginaRecordada, recordarPagina, olvidarPagina, fijarCampusPagina } from "../../../../utils/paginaRecordada";
import React, {
    useEffect,
    useMemo,
    useRef,
    useState
} from "react";

import { useLocation, useNavigate } from "react-router-dom";
import {
    useDispatch,
    useSelector
} from "react-redux";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sprintf } from "sprintf-js";
import {
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";

import Constants,
{
    FILTER_TYPES,
    FINANCES_MODALS,
    OPERATORS,
    paymentStatus
} from "../../../../constants";
import {
    RootState,
    enableIdleLockSwitch,
    disableIdleLockSwitch,
    displayNotice,
    AppDispatch,
    setCurrentUserCampus,
    setCurrentUserCampusId
} from "../../../../globals";
import HttpManager from "../../../../services/HttpManager";
import {
    setCurrentCampus,
    setCurrentCampusId,
    setPermissions,
    UserState
} from "../../../../redux/reducers/sessionReducer";
import { setPaymentMethods, setRecipientAccounts } from "../../../../redux/reducers/catalogReducer";
import {
    handlePaymentXlsx,
    handleSelectedPayment,
    setIsCancelPayment,
    setIsNewInvoice,
    setIsPartialPayment,
    setModalContent,
    setRefundItems,
    setSelectedInvoice,
    setSelectedPayment,
    setShowModal,
    setStudentData,
    setTotalToPaid
} from "../../../../redux/reducers/paymentsReducer";
import { handleSelectedInvoice, setSelectedCredit } from "../../../../redux/reducers/invoicesReducer";
import { Column } from "../../../../components/commonTable";
import SM from "../../../../components/modals/payments/multi/strings";
import PaymentView from "./paymentView";
import ButtonComponent from "../../../../components/buttons/button";
import TruncateTextComponent from "../../../../components/truncateText";
import { handleSelectedCredit } from "../../../../redux/reducers/creditsReducer";
import { styles } from "./style";
import { getErrorMessage } from "../../../../common";
import { ahoraCdmx } from "../../../../utils/horaMexico";
import { fechaHoraAmPm } from "../../../../utils/fechaHoraAmPm";
import useEnlaceDirecto from "../../../../utils/enlaceDirecto";

/*
    "Hoy" al MEDIODIA local, nunca new Date() a secas.

    Un Date se manda al servidor en UTC. En Monterrey, despues de las 6 de la
    tarde, el UTC ya es el dia siguiente: a las 8:36 PM un new Date() viajaba
    como "2026-09-22T02:36Z" y el filtro de hoy devolvia cero pagos. Asi lo
    reporto Esteban el 2026-09-21. Con el mediodia local (18:00 UTC) la fecha
    es la misma en las dos zonas, a cualquier hora del dia.
*/
const mediodiaDeHoy = () => {
    const ahora = ahoraCdmx();
    return new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), 12, 0, 0);
};

const PaymentController = (props: any, route: any) => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const location = useLocation();
    const pagesSize: number[] = [100, 50, 20, 10];   // 100 por página por defecto (Esteban, 2026-09-11)
    const http = HttpManager.getInstance();
    const idleLocked: boolean = useSelector((state: RootState) => state.idleLockSwitch.value);
    const userData: UserState | null = useSelector((state: RootState) => state.rootReducer.sessionState.user);
    const currentRole: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentRole);
    const currentCampus: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
    const campuses: any[] = useSelector((state: RootState) => state.rootReducer.catalog.campuses);
    const studentData: any = useSelector((state: RootState) => state.rootReducer.payments.studentData);
    const selectedInvoice: any = useSelector((state: RootState) => state.rootReducer.payments.selectedInvoice);
    const selectedPayment: any = useSelector((state: RootState) => state.rootReducer.payments.selectedPayment);
    const isPartialPayment: boolean = useSelector((state: RootState) => state.rootReducer.payments.isPartialPayment);
    const isNewInvoice: boolean = useSelector((state: RootState) => state.rootReducer.payments.isNewInvoice);
    const paymentStatuses: [] = useSelector((state: RootState) => state.rootReducer.catalog.paymentStatuses);
    const allowedPaymentMethods: [] = useSelector((state: RootState) => state.rootReducer.catalog.allowedPaymentMethods);
    const recipientAccountOptions: [] = useSelector((state: RootState) => state.rootReducer.catalog.recipientAccounts);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [payments, setPayments] = useState<any>(null);
    const [pages, setPages] = useState<any>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const paginaCargadaRef = useRef<boolean>(false);
    const [itemsPerPage, setItemsPerPage] = useState<number>(pagesSize[0]);
    const [itemCount, setItemCount] = useState<any>(null);
    const [searchValue, setSearchValue] = useState<string>("");
    /*
        Filtros rapidos. Esteban (2026-09-21) dijo que lo que de verdad se
        consulta es, en este orden: los pagos de HOY, los de efectivo mas
        terminal, y los de solo efectivo. Con "Hoy" encendido al abrir y dos
        chips de metodo se cubren los tres casos sin abrir ningun panel.

        Los ids de metodo salen del catalogo por nombre, no a mano: si manana
        alguien renombra o agrega un metodo, esto no se queda mintiendo.
    */
    const CHIPS_PAGOS = [
        { llave: "hoy", texto: "Hoy", ayuda: "Solo los pagos registrados hoy" },
        { llave: "efectivo", texto: "Efectivo", ayuda: "Solo los pagos en efectivo" },
        { llave: "terminal", texto: "Terminal", ayuda: "Solo los pagos con terminal POS" }
    ];
    const RAPIDOS_POR_OMISION = { hoy: true, efectivo: false, terminal: false };
    const [rapidos, setRapidos] = useState<{ [k: string]: boolean }>(RAPIDOS_POR_OMISION);

    /*
        Los filtros ARRANCAN con lo que dicen los chips por omision, no se les
        pega despues.

        Por que: al abrir salen varias peticiones casi a la vez. Si el filtro se
        aplicaba en un efecto posterior, la peticion SIN filtro podia terminar
        de ultima y pisar el resultado filtrado: el chip "Hoy" se veia encendido
        y la tabla mostraba los 85.273 pagos. Asi lo reporto Esteban el
        2026-09-21 ("me salieron un monton de pagos a pesar q use filtro hoy").
        Naciendo con el criterio puesto, todas las peticiones de la carga van
        filtradas y no hay carrera que perder.
    */
    const [filters, setFilters] = useState<{ [key: string]: any }>(() => {
        if (!RAPIDOS_POR_OMISION.hoy) { return {}; }

        const hoy = mediodiaDeHoy();
        return { createdAt: { start: hoy, end: hoy } };
    });
    const [createdAtRange, setCreatedAtRange] = useState<{ start: Date | null; end: Date | null }>({
        start: null,
        end: null,
    });
    const [paymentDateRange, setPaymentDateRange] = useState<{ start: Date | null; end: Date | null }>({
        start: null,
        end: null,
    });
    const [amount, setAmount] = useState<{ option: string; quantity: number }>({
        option: "",
        quantity: 0,
    });
    const filtersUpdatedRef = useRef(false);
    //Pago que pidió el enlace del reporte: al llegar su renglón se abre la ficha sola
    //(Esteban, 2026-09-12).
    const pagoDelEnlaceRef = useRef<number | null>(null);

    const onChangeSearch = (newSearchValue: string) => {
        setSearchValue(newSearchValue);
    }

    const onClickSearch = () => {
        setFilters({ ...filters, search: searchValue });
    }

    const onClearSearch = () => {
        setSearchValue("");
        setFilters({});
        clearQueryParams();
    }

    const onClearFilters = () => {
        setSearchValue("");
        setFilters({});
        clearQueryParams();
    }

    const updateFilters = (prevFilters: any, columnId: string, value: any) => {
        const updatedFilters = { ...prevFilters };

        if (columnId === "createdAt") {
            const { start, end } = value || {};
            if (value === null) {
                setCreatedAtRange({ start: null, end: null });
                delete updatedFilters[columnId];
                return JSON.stringify(updatedFilters) === JSON.stringify(prevFilters) ? prevFilters : updatedFilters;
            }
            if (!start || !end || start > end) {
                return JSON.stringify(updatedFilters) === JSON.stringify(prevFilters) ? prevFilters : updatedFilters;
            }
        }

        if (columnId === "paymentDate") {
            const { start, end } = value || {};
            if (value === null) {
                setPaymentDateRange({ start: null, end: null });
                delete updatedFilters[columnId];
                return JSON.stringify(updatedFilters) === JSON.stringify(prevFilters) ? prevFilters : updatedFilters;
            }
            if (!start || !end || start > end) {
                return JSON.stringify(updatedFilters) === JSON.stringify(prevFilters) ? prevFilters : updatedFilters;
            }
        }

        const handleQuantityFilter = (column: string) => {
            const { option, quantity } = value || {};
            if (!option || quantity < 0) {
                delete updatedFilters[column];
                if (column === "paidAmount") setAmount({ option: "", quantity: 0 });
            }
        };

        if (["paidAmount"].includes(columnId)) {
            handleQuantityFilter(columnId);
        }

        if (value === null) {
            if (updatedFilters[columnId]) {
                delete updatedFilters[columnId];
            }
        } else {
            updatedFilters[columnId] = value;
        }

        if (Array.isArray(value)) {
            if (value.length === 0) {
                delete updatedFilters[columnId];
            } else {
                updatedFilters[columnId] = value;
            }
        }

        return JSON.stringify(updatedFilters) === JSON.stringify(prevFilters) ? prevFilters : updatedFilters;
    };

    const onFilterChange = (columnId: string, value: any) => {
        setFilters((prevFilters) => {
            const newFilters = updateFilters(prevFilters, columnId, value);
            return newFilters;
        });
    };

    const paymentColumns: Column[] = [
        {
            id: "id",
            header: Constants.Common.id,
            accessor: "",
            render: (payment: any) => payment.id > 0
                ? <ButtonComponent className="wa-btn sm link"
                    tooltip={Constants.Common.paymentDetail}
                    style={{ opacity: idleLocked ? 0.5 : 1 }}
                    disabled={idleLocked}
                    onClick={() => showPaymentDetail(payment)}
                >
                    {payment.id.toString()}
                </ButtonComponent>
                : "-",
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            }),
            filterType: FILTER_TYPES.INPUT_NUMBER,
            defaultFilterValue: filters?.id ?? "",
            filterEnabled: filters?.id > 0,
            overrideCellStyle: (data: any) => ({
                color: data.statusId === paymentStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "center",
                width: "60px",
            })
        },
        {
            id: "reference",
            header: Constants.Common.reference,
            accessor: "",
            filterType: FILTER_TYPES.INPUT_TEXT,
            render: (payment: any) => (
                <TruncateTextComponent
                    value={payment.reference ? payment.reference : "-"}
                    maxLength={10}
                    maxWidth={"100%"}
                />
            ),
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === paymentStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "center",
                whiteSpace: "inherit",
                width: "80px"
            })
        },
        {
            id: "correlative",
            header: Constants.Common.correlative,
            accessor: "studentIdentityCode",
            filterType: FILTER_TYPES.INPUT_TEXT,
            overrideCellStyle: (data: any) => ({
                color: data.statusId === paymentStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "center",
                whiteSpace: "inherit",
                width: "108px"
            }),
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            })
        },
        {
            /*
                Nombres y Apellidos eran DOS columnas de 118 y 128px. Con catorce
                columnas la tabla no cabia en una laptop de 11-12" y habia que
                arrastrar de lado. Van juntas. (Esteban, 2026-09-21)
            */
            id: "studentName",
            tituloEnTelefono: true,
            renderTituloEnTelefono: (payment: any) =>
                [payment.studentFirstname, payment.studentLastname].filter(Boolean).join(" "),
            header: Constants.Common.colAlumno,
            accessor: "",
            /*
                En pantalla angosta se deja el primer nombre y el primer apellido:
                al lado va el correlativo, que ya distingue a dos homonimos.
                (Esteban, 2026-09-21)
            */
            render: (payment: any) => {
                const nombres = String(payment.studentFirstname || "").trim()
                const apellidos = String(payment.studentLastname || "").trim()
                const completo = [nombres, apellidos].filter(Boolean).join(" ")
                const corto = [nombres.split(/\s+/)[0], apellidos.split(/\s+/)[0]]
                    .filter(Boolean).join(" ")

                return <>
                    <span className="waNombreLargo">{completo || "-"}</span>
                    <span className="waNombreCorto">{corto || "-"}</span>
                </>
            },
            filterType: FILTER_TYPES.INPUT_TEXT,
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === paymentStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "left",
                whiteSpace: "inherit",
                width: "150px"
            })
        },
        {
            id: "invoiceId",
            header: Constants.Common.invoice,
            accessor: "",
            filterType: FILTER_TYPES.INPUT_NUMBER,
            render: (payment: any) => payment.invoiceId > 0
                ? <ButtonComponent className="wa-btn sm link"
                    tooltip={Constants.Common.invoiceDetail}
                    style={{ opacity: idleLocked ? 0.5 : 1 }}
                    disabled={idleLocked}
                    onClick={() => getInvoiceById(payment.invoiceId, payment.studentId)}
                >
                    {payment.invoiceId.toString()}
                </ButtonComponent>
                : "-",
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === paymentStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "center",
                whiteSpace: "inherit",
                width: "80px"
            })
        },
        {
            id: "paidAmount",
            //Arriba a la derecha de la tarjeta: es lo primero que se busca de un pago.
            enCabeceraEnTelefono: true,
            header: Constants.Common.colPagado,
            accessor: "",
            render: (payment) => `${payment.amount.moneyFormat}`,
            filterType: FILTER_TYPES.AMOUNT_RANGE,
            quantityRangeState: {
                option: amount.option,
                setOption: (option: string) => setAmount((prev) => ({ ...prev, option })),
                quantity: amount.quantity,
                setQuantity: (quantity: number) => setAmount((prev) => ({ ...prev, quantity })),
            },
            filterOptions: OPERATORS,
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === paymentStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "right",
                whiteSpace: "inherit",
                width: "96px"
            }),
        },
        {
            id: "paymentMethod",
            header: Constants.Common.colMetodo,
            accessor: "paymentMethod",
            /*
                "Terminal POS" -> "Terminal" y "Transferencia" -> "Transfer": son
                los dos metodos mas usados y los que mas ancho pedian. El nombre
                completo queda en el titulo al pasar el mouse.
                (Esteban, 2026-09-21)
            */
            render: (payment: any) => {
                const completo = String(payment.paymentMethod || "")
                const corto = completo
                    .replace(/^Terminal POS$/i, "Terminal")
                    .replace(/^Transferencia$/i, "Transfer")

                return <span title={completo}>{corto || "-"}</span>
            },
            filterType: FILTER_TYPES.MULTISELECT,
            filterOptions: allowedPaymentMethods,
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === paymentStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "left",
                whiteSpace: "inherit",
                width: "96px"
            }),
        },
        {
            id: "recipientAccount",
            header: Constants.Common.colCuenta,
            accessor: "recipientAccount",
            filterType: FILTER_TYPES.MULTISELECT,
            filterOptions: recipientAccountOptions,
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === paymentStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "center",
                whiteSpace: "inherit",
                width: "132px"
            })
        },
        {
            id: "paymentStatus",
            header: Constants.Common.status,
            accessor: "",
            /*
                Aprobado y Anulado son el 99% de los pagos y ocupaban una columna
                entera de texto. Van como marca: palomita verde y equis roja. La
                equis y no una flecha de retorno, que se leeria como devolucion.
                Los demas estatus siguen en palabras, que son pocos y no se
                adivinan. El titulo al pasar el mouse siempre dice la palabra.
                (Esteban, 2026-09-21)
            */
            render: (data: any) => {
                const marca = data.statusId === paymentStatus.APPROVED
                    ? {icono: solid("circle-check"), color: "var(--wa-verde)"}
                    : (data.statusId === paymentStatus.CANCELLED
                        ? {icono: solid("circle-xmark"), color: "var(--wa-rojo)"}
                        : null)

                if (marca === null) {
                    return <span
                        title={data.status}
                        style={{font: Constants.Styles.text.fonts.robotoBold14}}>
                        {data.status}
                    </span>
                }

                return <span title={data.status} aria-label={data.status}>
                    <FontAwesomeIcon icon={marca.icono} style={{color: marca.color, fontSize: "18px"}} />
                </span>
            },
            filterType: FILTER_TYPES.MULTISELECT,
            filterOptions: paymentStatuses,
            //La palomita y la equis van centradas: sueltas a la izquierda se ven raras.
            overrideCellStyle: () => ({
                width: "64px",
                textAlign: "center"
            }),
            /*
                El encabezado NO se centra: la tabla pone el embudo antes del
                titulo cuando la columna va centrada, y quedaba un embudo suelto
                a la izquierda de "Estatus", como si fuera de otra columna.
                Se centra solo el contenido. (Esteban, 2026-09-21)
            */
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            })
        },
        {
            id: "createdAt",
            header: Constants.Common.colFechaCreacion,
            accessor: "createdAt",
            render: (payment: any) => <span title={String(payment.createdAt ?? "")}>{fechaCorta(payment.createdAt)}</span>,
            filterType: FILTER_TYPES.DATE_RANGE,
            dateRangeState: {
                start: createdAtRange.start,
                end: createdAtRange.end,
                setStart: (date: Date | null) => setCreatedAtRange((prev) => ({ ...prev, start: date })),
                setEnd: (date: Date | null) => setCreatedAtRange((prev) => ({ ...prev, end: date })),
            },
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === paymentStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "left",
                whiteSpace: "inherit",
                width: "98px"
            }),
        },
        {
            id: "paymentDate",
            header: Constants.Common.colFechaPago,
            accessor: "paymentDate",
            render: (payment: any) => <span title={String(payment.paymentDate ?? "")}>{fechaCorta(payment.paymentDate)}</span>,
            filterType: FILTER_TYPES.DATE_RANGE,
            dateRangeState: {
                start: paymentDateRange.start,
                end: paymentDateRange.end,
                setStart: (date: Date | null) => setPaymentDateRange((prev) => ({ ...prev, start: date })),
                setEnd: (date: Date | null) => setPaymentDateRange((prev) => ({ ...prev, end: date })),
            },
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === paymentStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "left",
                whiteSpace: "inherit",
                width: "98px"
            }),
        },
        {
            id: "notes",
            header: Constants.Common.notes,
            accessor: "",
            filterType: FILTER_TYPES.INPUT_TEXT,
            /*
                Antes se cortaba a los 10 caracteres: se leia "Líquida ma..." y la
                nota es de lo mas importante de un pago. La columna ahora mide
                240px y aguanta bastante mas. (Esteban, 2026-09-21)
            */
            render: (payment: any) => (
                <TruncateTextComponent
                    value={payment.notes}
                    maxLength={60}
                    maxWidth={"100%"}
                />
            ),
            overrideHeaderStyle: () => ({
                ...styles.tableHeaderStyle
            }),
            overrideCellStyle: (data: any) => ({
                color: data.statusId === paymentStatus.CANCELLED
                    ? Constants.Styles.text.colors.red
                    : Constants.Styles.text.colors.blackPrimary,
                textAlign: "center",
                whiteSpace: "inherit",
                width: "240px"
            }),
        },
        {
            id: "selectPayment",
            header: "",
            accessor: "",
            render: () => <React.Fragment></React.Fragment>,
            /*
                width 1%: sin esto la celda se queda con TODO el sobrante de la
                fila y el boton "Ver" se va al extremo derecho, dejando un palmo
                de vacio despues de Notas. Con 1% la celda mide lo que mide su
                boton y el sobrante se reparte entre las columnas de texto. Es el
                mismo arreglo que ya se hizo en la tabla de Personal.
                (Esteban, 2026-09-21)
            */
            overrideCellStyle: () => ({
                width: "1%",
                textAlign: "center",
                borderBottom: 0
            }),
            overrideHeaderStyle: () => ({
                width: "1%",
                textAlign: "center",
                color: "var(--wa-tinta)"
            })
        }
    ];

    /*
        Pagos y Movimientos (Esteban, 2026-09-22): la fila "Pago" es lo que entró al banco; debajo,
        con sangría, van sus movimientos (uno por alumno). Un pago de una sola persona se ve como
        siempre. Las filas de pago se insertan aquí, no vienen del servidor: el servidor manda los
        movimientos ya ordenados (los de un mismo pago juntos, M1, M2...).
    */
    const conFilasDePago = (rows: any[]): any[] => {
        const out: any[] = [];
        let ultimo: string | null = null;
        (rows || []).forEach((p: any) => {
            if (p.isMulti && p.receiptNumber !== ultimo) {
                out.push({
                    isReceiptRow: true, id: Number(p.receiptNumber), receiptNumber: p.receiptNumber, receiptTotal: p.receiptTotal,
                    movementCount: p.movementCount, personCount: Number(p.personCount || 1),   // del servidor: todos los movimientos del pago, de cualquier plantel y página payerName: p.payerName, statusId: p.receiptCancelled ? paymentStatus.CANCELLED : paymentStatus.APPROVED,
                    status: p.receiptCancelled ? "Anulado" : "Aprobado",
                    currencyCode: p.currencyCode, paymentMethod: p.paymentMethod, recipientAccount: p.recipientAccount, reference: p.receiptReference || p.reference,
                    paymentDate: p.paymentDate, createdAtDateTime: p.createdAtDateTime, createdAt: p.createdAt, notes: "", studentFirstname: "", studentLastname: "", studentIdentityCode: "",
                    // El total con el mismo formato que los movimientos (Money del servidor: símbolo + 2 decimales, «L1240.00»).
                    receiptMoney: String(p.amount?.moneyFormat || "").replace(/[-\d.,\s]+$/, "") + Number(p.receiptTotal || 0).toFixed(2)
                });
            }
            ultimo = p.isMulti ? p.receiptNumber : null;
            out.push(p);
        });
        return out;
    };
    const [receiptDetailId, setReceiptDetailId] = useState<number | null>(null);
    const [showMulti, setShowMulti] = useState<boolean>(false);
    // Descuentos especiales: Supervisión de Caja llega por el enlace del aviso de Cliq (/payments?descuento=N&plantel=X).
    const [discountsOpen, setDiscountsOpen] = useState<boolean>(false);
    const [discountFocus, setDiscountFocus] = useState<number | null>(null);
    const enlace = useEnlaceDirecto("descuento", (id) => { setDiscountFocus(id); setDiscountsOpen(true); });
    const celdaDePago = (column: any, row: any): React.ReactNode => {
        switch (column.id) {
            case "id": return <ButtonComponent className="wa-btn sm link" style={{ fontWeight: 700 }} disabled={idleLocked} onClick={() => setReceiptDetailId(row.id)}>{"Pago " + row.id}</ButtonComponent>;
            case "reference": return row.reference || "-";
            case "studentName": return <span>{row.personCount > 1 ? row.personCount + " personas · " : "1 persona · "}{row.movementCount} movimientos{row.payerName ? " · pagó " + row.payerName : ""}</span>;
            case "paidAmount": return <b>{row.receiptMoney}</b>;
            case "paymentMethod": return row.paymentMethod;
            case "recipientAccount": return row.recipientAccount;
            // Hora local del plantel en am/pm y sin segundos: la misma que enseña el detalle del pago y su PDF.
            case "createdAt": return fechaHoraAmPm(row.createdAtDateTime || row.createdAt || "");
            case "paymentDate": return fechaCorta(row.paymentDate);
            case "notes": return <span style={{ color: "var(--wa-apagado)" }}>{row.movementCount} movimientos</span>;
            case "selectPayment": return <button className="btn btn-default" type="button" disabled={idleLocked} onClick={() => setReceiptDetailId(row.id)}><span className="waVer">Ver</span></button>;
            default: return "";
        }
    };

    const paymentColumnsWithLogic = paymentColumns.map((column: any) => {
        const original = column.render;
        const originalStyle = column.overrideCellStyle;
        const originalTitulo = column.renderTituloEnTelefono;
        column = {
            ...column,
            // En telefono la tarjeta del pago se titula con su numero, no con un alumno.
            ...(originalTitulo ? { renderTituloEnTelefono: (row: any) => row.isReceiptRow
                ? (row.payerName || (row.personCount > 1 ? `${row.personCount} personas` : `1 persona · ${row.movementCount} movimientos`)) : originalTitulo(row) } : {}),
            render: (row: any) => row.isReceiptRow && column.id !== "paymentStatus" ? celdaDePago(column, row)
                : (column.id === "id" && row.isMulti
                    ? <span style={{ whiteSpace: "nowrap" }}><span style={{ color: "var(--wa-apagado)" }}>└&nbsp;</span>
                        <ButtonComponent className="wa-btn sm link" tooltip={Constants.Common.paymentDetail} style={{ opacity: idleLocked ? 0.5 : 1 }} disabled={idleLocked} onClick={() => showPaymentDetail(row)}>{row.movementLabel || row.id.toString()}</ButtonComponent></span>
                    : (original ? original(row) : row[column.accessor])),
            overrideCellStyle: (row: any) => ({
                ...(originalStyle ? originalStyle(row) : {}),
                ...(row.isReceiptRow ? { background: "var(--wa-papel)", fontWeight: 700, borderTop: "2px solid var(--wa-filo)" } : {}),
                ...(row.isMulti && column.id === "id" ? { paddingLeft: "22px", textAlign: "left" } : {})
            })
        };
        if (column.id === "selectPayment" && column.render) {
            return {
                ...column,
                render: (payment: any) => (
                    <OverlayTrigger overlay={
                        <Tooltip>
                            {Constants.Common.paymentDetail}
                        </Tooltip>
                    }>
                        <button
                            className="btn btn-default"
                            type="button"
                            disabled={idleLocked}
                            onClick={() => payment.isReceiptRow ? setReceiptDetailId(payment.id) : showPaymentDetail(payment)}
                        >
                            <span className="waVer">Ver</span>
                        </button>
                    </OverlayTrigger>
                ),
            };
        }
        return column;
    });

    const fetchRoleData = async () => {
        try {
            const response = await http.roleService.getRoleData(currentRole.id);
            dispatch(setPermissions(response.data.permissions));
            return response.data;
        } catch (err: any) {
            console.error(err);
        }
    }

    const handlePageSizeChange = (newPageSize: number) => {
        setItemsPerPage(newPageSize);
    }

    const resetStateData = () => {
        dispatch(setRefundItems(new Set()));
        dispatch(setIsPartialPayment(false));
    }

    const onError = (message: string) => {
        dispatch(displayNotice({
            cornerClose: false,
            message: message,
            heading: <h3 style={{
                color: "var(--wa-rojo-error)",
                display: "inline-block"
            }}>
                Error
            </h3>
        }));
    }

    const getStudentById = async (studentId: number) => {
        try {
            let response = await http.studentService.getStudentById(
                currentCampus.id,
                studentId
            );
            let student = response.data;
            return student;
        } catch (error) {
            console.log(error);
            onError(getErrorMessage(error));
        }
    }

    const setSelectedStudent = async (data: any) => {
        const studentData = await getStudentById(data.studentId);
        dispatch(setStudentData(studentData));
    }

    const getPaymentMethods = async () => {
        try {
            const response = await http.paymentMethodService
                .getPaymentMethodsByCountry(currentCampus.countryId);
            const paymentMethods = response.data;
            return paymentMethods;
        } catch (err: any) {
            console.error(err);
        }
    }

    const getRecipientAccounts = async () => {
        try {
            const response = await http.recipientAccountService
                .getRecipientAccounts(currentCampus.countryId);
            const accounts = response.data;
            return accounts;
        } catch (err: any) {
            console.error(err);
        }
    }

    const getPaymentsByCampusId = async (page?: number) => {
        try {
            const response = await http.paymentService.getPaymentsByCampusId(
                userData?.token ?? "",
                currentCampus.id,
                itemsPerPage,
                filters,
                page
            );
            const payments = response.data;
            return payments;
        } catch (err: any) {
            console.error(err);
        }
    }


    /*
        Se le quita el cero de adelante al mes: "20/09/2026" -> "20/9/2026". El
        ano va completo: se probo con dos cifras y Esteban lo prefiere entero
        (2026-09-21). El titulo al pasar el mouse conserva la fecha tal cual.
    */
    const fechaCorta = (valor: any) => {
        const texto = String(valor ?? "").trim()
        const partes = texto.split("/")

        if (partes.length !== 3) { return texto || "-" }

        //Siempre dd/mm/aaaa (2026-10-09: «7/10/2026» y «07/10/2026» convivían en la misma lista).
        return String(+partes[0]).padStart(2, "0") + "/" + String(+partes[1]).padStart(2, "0") + "/" + partes[2]
    }

    const handleDownloadReport = async () => {
        try {
            dispatch(enableIdleLockSwitch());
            await dispatch(handlePaymentXlsx({
                campusId: currentCampus.id,
                criteria: filters
            })).unwrap(); // unwrap para manejar correctamente errores en createAsyncThunk;
        } catch (error) {
            onError("Hubo un error al tratar de obtener el documento!");
        }
        finally {
            dispatch(disableIdleLockSwitch());
        }
    }

    /* Vuelve a pedir la página actual y la pinta (después de registrar o anular un pago). */
    const refrescarPagos = async () => {
        const payments = await getPaymentsByCampusId();
        if (payments) {
            updatePaginationInfo(payments);
            setPayments(conFilasDePago(payments.data));
        }
    };

    const getPaginatedPayments = async (url: string) => {
        dispatch(enableIdleLockSwitch())
        try {
            const response = await http.paymentService.getPaginatedPayments(
                userData?.token ?? "", url);
            const payments = response.data;
            updatePaginationInfo(payments);
            setPayments(conFilasDePago(payments.data));
            return payments;
        } catch (err: any) {
            console.error(err);
        } finally {
            setIsLoaded(true);
            dispatch(disableIdleLockSwitch());
        }
    }

    const updatePaginationInfo = (pagination: any) => {
        const updatedPages = pagination.links.map((page: any) => ({
            ...page,
            onClick: () => {
                if (page.url) {
                    getPaginatedPayments(page.url);
                }
            }
        }));
        setItemCount({
            start: pagination.from,
            end: pagination.to,
            total: pagination.total
        });
        setPages(updatedPages);
        setCurrentPage(pagination.current_page);
        recordarPagina(pagination.current_page);
    }

    /*
        El alumno sale de la fila que se abrió (o de la factura abierta), no de studentData: ese llega después y en la siguiente
        apertura todavía es el del alumno anterior (pedía …/students/undefined/… o la factura con otro alumno). Sin alumno no se pide.
    */
    const getInvoiceById = async (invoiceId: number, studentId?: number | null) => {
        const alumno = Number(studentId || (selectedInvoice && Number(selectedInvoice.id) === Number(invoiceId) ? selectedInvoice.studentId : 0) || 0);
        if (!invoiceId || !alumno) {
            return;
        }
        try {
            dispatch(enableIdleLockSwitch());
            let response = await dispatch(handleSelectedInvoice({
                sessionToken: userData?.token ?? "",
                campusId: currentCampus.id,
                studentId: alumno,
                invoiceId
            })).unwrap();
            let invoice = response.data;
            setSelectedStudent(invoice);
            dispatch(setSelectedInvoice(invoice));
            dispatch(setTotalToPaid(invoice.pendingAmount));
            dispatch(setIsNewInvoice(false));
            dispatch(setShowModal(true));
        } catch (error) {
            onError("Hubo un error al tratar de obtener el documento!");
        }
        finally {
            dispatch(disableIdleLockSwitch());
        }
    }

    const showPaymentDetail = async (rowData: any) => {
        try {
            dispatch(enableIdleLockSwitch());
            const response = await dispatch(handleSelectedPayment({
                sessionToken: userData?.token ?? "",
                campusId: currentCampus.id,
                paymentId: rowData.id
            })).unwrap();
            const payment = {
                ...response.data,
                account: response.data.recipientAccount,
                amount: response.data.amount.value,
                files: response.data.documents
            };
            setSelectedStudent(payment);
            dispatch(setSelectedPayment(payment));
            dispatch(setModalContent(FINANCES_MODALS.PAYMENT_DETAIL));
            dispatch(setShowModal(true));
        } catch (error) {
            onError("Hubo un error al tratar de obtener el documento!");
        }
        finally {
            dispatch(disableIdleLockSwitch());
        }
    }

    const showCreditDetail = async (rowData: any) => {
        try {
            dispatch(enableIdleLockSwitch());
            let response = await dispatch(handleSelectedCredit({
                campusId: currentCampus.id,
                creditId: rowData.id
            })).unwrap();
            const credit = response.data;
            dispatch(setSelectedCredit(credit));
            dispatch(setModalContent(FINANCES_MODALS.APPLY_CREDIT_DETAILS));
            dispatch(setShowModal(true));
        } catch (error) {
            onError("Hubo un error al tratar de obtener el documento!");
        }
        finally {
            dispatch(disableIdleLockSwitch());
        }
    }

    const cancelInvoice = () => {
        dispatch(setModalContent(FINANCES_MODALS.CANCEL_INVOICE));
    }

    const proccessPayment = () => {
        dispatch(setIsPartialPayment(true));
        dispatch(setIsNewInvoice(false));
        dispatch(setModalContent(FINANCES_MODALS.EMIT_PAYMENT));
    }

    const closeModalInvoiceDetail = () => {
        dispatch(setIsPartialPayment(false));
        dispatch(setShowModal(false));
        dispatch(setSelectedInvoice(null));
    }

    const handleCancelPayment = () => {
        setIsCancelPayment(true);
        dispatch(setModalContent(FINANCES_MODALS.CANCEL_PAYMENT));
    }

    const paymentDetailCloseModal = () => {
        dispatch(setShowModal(false));
    }

    const showPaymentUpdateModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.UPDATE_PAYMENT));
    }

    const updatePaymentCloseModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.PAYMENT_DETAIL))
    }

    const onSuccessUpdatePayment = () => {
        dispatch(setModalContent(FINANCES_MODALS.PAYMENT_DETAIL));
        showSuccessMessage();
        showPaymentDetail(selectedPayment);
    }

    const showSuccessMessage = () => {
        dispatch(displayNotice({
            cornerClose: false,
            message: "Información procesada con éxito",
            heading: <h3 style={{
                color: "var(--wa-verde)", display: "inline-block"
            }}>
                Listo
            </h3>
        }));
    }

    const cancelPaymentCloseModal = () => {
        setIsCancelPayment(false);
        dispatch(setModalContent(FINANCES_MODALS.PAYMENT_DETAIL));
    }

    const onSuccessCancelPayment = () => {
        fetchData();
        if (selectedInvoice) {
            getInvoiceById(selectedInvoice.id, selectedInvoice.studentId);
        }
        dispatch(setShowModal(true));
        showPaymentDetail(selectedPayment);
        showSuccessMessage();
    }

    const cancelEmitPayment = () => {
        if (isPartialPayment && !isNewInvoice) {
            dispatch(setModalContent(FINANCES_MODALS.INVOICE));
        } else {
            dispatch(setModalContent(FINANCES_MODALS.CHECKOUT));
        }
    }

    const showApplyCreditModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.APPLY_CREDIT));
    }

    const onSuccessEmitPayment = () => {
        fetchData();
        getInvoiceById(selectedInvoice.id, selectedInvoice.studentId);
        dispatch(setShowModal(true));
        dispatch(displayNotice({
            cornerClose: false,
            message: "Información procesada con éxito",
            heading: <h3 style={{
                color: "var(--wa-verde)", display: "inline-block"
            }}>
                Listo
            </h3>
        }));
    }

    const closeModalEmitPayment = () => {
        dispatch(setShowModal(false));
    }

    const cancelInvoiceCloseModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.INVOICE));
    }

    const onSuccessCancelInvoice = () => {
        fetchData();
        dispatch(setShowModal(false));
        dispatch(displayNotice({
            cornerClose: false,
            message: "Información procesada con éxito",
            heading: <h3 style={{
                color: "var(--wa-verde)", display: "inline-block"
            }}>
                Listo
            </h3>
        }))
    }

    const generateInvoiceCloseModal = () => {
        dispatch(setModalContent(FINANCES_MODALS.CHECKOUT));
    }

    const onSuccessGeneratePaidInvoice = () => {
        fetchData();
        dispatch(setShowModal(false));
        showSuccessMessage();
    }

    const getQueryParams = () => {
        const query = new URLSearchParams(location.search);
        const data = query.get("data");
        if (!data) {
            return { campusId: 0, invoiceId: 0 };
        }

        try {
            const decodedData = JSON.parse(decodeURIComponent(data));
            return {
                campusId: decodedData?.campus ?? 0,
                paymentId: decodedData?.payment ?? 0
            };
        } catch (error) {
            console.error("Error al parsear JSON de query params:", error);
            return { campusId: 0, invoiceId: 0 };
        }
    }

    const clearQueryParams = () => {
        const query = new URLSearchParams(location.search);

        query.forEach((value, key) => {
            query.delete(key);  // delete each parameter
        });

        window.history.replaceState(
            null,
            '',
            `${location.pathname}${location.hash}`  // holding hash, but delete all query params
        );
    }

    const handleCampusChange = (campusId: number) => {
        localStorage.setItem("currentCampus", `C_${campusId}`);
        dispatch(setCurrentUserCampusId(campusId));
        dispatch(setCurrentUserCampus(`C_${campusId}`));
        dispatch(setCurrentCampusId(campusId));
        const newCampus = campuses.find((campus: any) => campus.id === campusId);
        //Sin catálogo (llegó por el puente de app.washingtonacademy.mx) no se pisa el plantel con un vacío:
        //app.tsx pide el catálogo y lo sincroniza (2026-10-21).
        if (newCampus) {
            dispatch(setCurrentCampus(newCampus));
        }
    }

    const fetchData = async (page?: number) => {
        resetStateData();
        const messageError: string = "Ocurrió un error al obtener los pagos."
        dispatch(enableIdleLockSwitch())
        if (currentCampus && userData) {
            try {
                const [
                    paymentMethods,
                    recipientAccounts,
                    payments
                ] = await Promise.all([
                    getPaymentMethods(),
                    getRecipientAccounts(),
                    getPaymentsByCampusId(page)
                ]);
                setPayments(conFilasDePago(payments.data));
                updatePaginationInfo(payments);
                dispatch(disableIdleLockSwitch());
                dispatch(setPaymentMethods(paymentMethods));
                dispatch(setRecipientAccounts(recipientAccounts));
                setIsLoaded(true);
            }
            catch (error: any) {
                dispatch(disableIdleLockSwitch());
                if (error.status === 404) {
                    navigate("/");
                }
                else {
                    console.log(error);
                    onError(messageError);
                }
            }
        }
    }

    /*
        Los chips mandan sobre los mismos criterios que los filtros de columna:
        "Hoy" escribe el rango de createdAt y los de metodo escriben la lista de
        method_id. Asi el servidor no necesita saber nada nuevo y el reporte que
        se descarga sale con el mismo recorte que se ve en pantalla.

        OJO CON LAS DEPENDENCIAS. La primera version dependia del arreglo de
        metodos que devuelve el selector y creaba un Date nuevo en cada vuelta:
        las dos cosas cambian de identidad en cada render, asi que el efecto se
        repetia sin parar y la pantalla pedia 68 veces la lista de pagos hasta
        que el servidor respondia 429. Ahora depende de TEXTO (los ids y el dia
        en YYYY-MM-DD), que solo cambia cuando cambia de verdad.
    */
    const idsDeMetodosRapidos = useMemo(
        () => {
            const buscar = (nombre: RegExp) => {
                const encontrado: any = (allowedPaymentMethods || [])
                    .find((m: any) => nombre.test(String(m?.name || "")));
                return encontrado ? encontrado.id : null;
            };

            return [
                rapidos.efectivo ? buscar(/^efectivo$/i) : null,
                rapidos.terminal ? buscar(/terminal/i) : null
            ].filter((x) => x != null);
        },
        [rapidos.efectivo, rapidos.terminal, allowedPaymentMethods]
    );

    const clyaveDeMetodos = idsDeMetodosRapidos.join(",");
    //toISOString() da el dia en UTC; aqui hace falta el dia LOCAL.
    const diaDeHoy = rapidos.hoy ? mediodiaDeHoy().toDateString() : "";

    useEffect(() => {
        const desde = diaDeHoy === "" ? null : mediodiaDeHoy();

        setCreatedAtRange((previo) => {
            const igual = (previo.start === null && desde === null) ||
                (previo.start != null && desde != null &&
                    previo.start.toISOString().slice(0, 10) === diaDeHoy);

            return igual ? previo : { start: desde, end: desde };
        });

        setFilters((previos) => {
            const nuevos: any = { ...previos };

            if (desde !== null) {
                nuevos.createdAt = { start: desde, end: desde };
            } else {
                delete nuevos.createdAt;
            }

            if (clyaveDeMetodos !== "") {
                nuevos.paymentMethod = clyaveDeMetodos.split(",").map((x: string) => +x);
            } else {
                delete nuevos.paymentMethod;
            }

            return JSON.stringify(nuevos) === JSON.stringify(previos) ? previos : nuevos;
        });
    }, [diaDeHoy, clyaveDeMetodos]);


    useEffect(() => {
        fetchRoleData();
    }, [currentRole]);

    useEffect(() => {
        if (selectedInvoice && Object.keys(selectedInvoice).length > 0) {
            dispatch(setShowModal(true));
            dispatch(setModalContent(FINANCES_MODALS.INVOICE));
        }
    }, [selectedInvoice]);

    //El enlace del reporte abre la ficha del pago directamente, sin tener que dar clic.
    useEffect(() => {
        const pagoEnlazado = pagoDelEnlaceRef.current;
        if (pagoEnlazado == null || payments == null) {
            return;
        }
        const renglon = payments.find((pago: any) => Number(pago.id) === Number(pagoEnlazado));
        pagoDelEnlaceRef.current = null;
        if (renglon) {
            showPaymentDetail(renglon);
        } else {
            onError("El pago del enlace ya no está disponible en este plantel.");
        }
    }, [payments]);

    useEffect(() => {
        if (userData?.token && currentCampus != null) {
            const { campusId, paymentId } = getQueryParams();
            if (campusId > 0 && paymentId > 0 && !filtersUpdatedRef.current) {
                handleCampusChange(campusId);
                //El enlace manda: se olvida la página recordada, porque el resultado filtrado
                //tiene una sola página y volver a la recordada dejaba la lista vacía
                //(reporte de pagos, Esteban 2026-09-12).
                olvidarPagina();
                paginaCargadaRef.current = true;
                setCurrentPage(1);
                pagoDelEnlaceRef.current = paymentId;
                setFilters({ ...filters, "id": paymentId });
                filtersUpdatedRef.current = true;
                return;
            }
            // Página recordada (utils/paginaRecordada): al volver de un perfil o
            // estado de cuenta se retoma la última página de este módulo y plantel.
            // Cualquier cambio posterior (filtros, plantel, tamaño de página) vuelve a la 1.
            fijarCampusPagina(currentCampus.id);
            const primeraCarga = !paginaCargadaRef.current;
            paginaCargadaRef.current = true;
            if (!primeraCarga) olvidarPagina();
            const pagina = primeraCarga ? paginaRecordada() : 1;
            if (filters?.search === "") {
                setCurrentPage(pagina);
                fetchData(pagina);
                return;
            }
            fetchData(pagina);
        } else {
            onError(
                "No hay planteles registrados o asignados al rol en uso por el usuario, " +
                "por lo que el acceso a este módulo permanecerá deshabilitado."
            )
        }
    }, [userData, currentCampus, itemsPerPage, filters]);

    useEffect(() => {
        if (filters.id) {
            fetchData();
        }
    }, [filters]);

    return !isLoaded || currentCampus == null || userData === null
        ? <React.Fragment></React.Fragment>
        : <PaymentView
            multiProps={{
                show: showMulti,
                open: () => setShowMulti(true),
                close: () => setShowMulti(false),
                onSuccess: (receipt: any) => { setShowMulti(false); refrescarPagos(); setReceiptDetailId(Number(receipt.id)); },
                campusId: currentCampus?.id,
                countryId: currentCampus?.countryId,
                currencySymbol: currentCampus?.currency || "",
                discounts: { open: discountsOpen, focusId: discountFocus, show: () => { setDiscountFocus(null); setDiscountsOpen(true); }, close: () => setDiscountsOpen(false) },
                avisoEnlace: { texto: enlace.aviso, cerrar: enlace.cerrar }
            }}
            receiptProps={{
                id: receiptDetailId,
                close: () => setReceiptDetailId(null),
                onCancelled: () => refrescarPagos(),
                onOpenMovement: (paymentId: number) => { setReceiptDetailId(null); showPaymentDetail({ id: paymentId }); },
                campusId: currentCampus?.id
            }}
            paymentProps={{
                payments,
                columns: paymentColumnsWithLogic,
                filters,
                onFilterChange,
                onClearFilters,
                reportFunction: handleDownloadReport,
                chips: CHIPS_PAGOS,
                rapidos,
                onRapidos: setRapidos,
                rapidosPorOmision: RAPIDOS_POR_OMISION
            }}
            paginationProps={{
                pages,
                pagesSize,
                itemCount,
                handlePageSizeChange
            }}
            searchProps={{
                search: searchValue,
                onChangeSearch,
                onClickSearch,
                onClearSearch
            }}
            invoiceDetailProps={{
                cancelInvoice,
                showPaymentDetail,
                showCreditDetail,
                proccessPayment,
                closeModal: closeModalInvoiceDetail
            }}
            emitPaymentProps={{
                isNewInvoice,
                isPartialPayment,
                closeModal: closeModalEmitPayment,
                cancelEmitPayment,
                showApplyCreditModal,
                onSuccess: onSuccessEmitPayment
            }}
            paymentDetailProps={{
                onReceiptCancelled: () => refrescarPagos(),
                handleCancelPayment,
                closeModal: paymentDetailCloseModal,
                showPaymentUpdate: showPaymentUpdateModal
            }}
            paymentUpdateProps={{
                onSuccess: onSuccessUpdatePayment,
                closeModal: updatePaymentCloseModal
            }}
            cancelPaymentProps={{
                closeModal: cancelPaymentCloseModal,
                onSuccess: onSuccessCancelPayment
            }}
            cancelInvoiceProps={{
                closeModal: cancelInvoiceCloseModal,
                onSuccess: onSuccessCancelInvoice
            }}
            generateInvoiceProps={{
                onSuccess: onSuccessGeneratePaidInvoice,
                closeModal: generateInvoiceCloseModal
            }}
        />
}

export default PaymentController;